export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";